import { z } from 'zod/v3';
import { FeedbackStatusSchema } from '../generated/enums';

export const FeedbackSignalSummaryFindingSchema = z.object({
  docId: z.string().optional(),
  title: z.string(),
  status: z.enum(['COVERED', 'MISSING', 'OUTDATED', 'UNKNOWN']).optional(),
  notes: z.string().optional(),
});

export const FeedbackSignalSummaryEvidenceSchema = z.object({
  sourceId: z.string().optional(),
  sourceType: z.string().optional(),
  title: z.string(),
  excerpt: z.string().optional(),
  url: z.string().url().optional(),
});

export const FeedbackSignalSummarySchema = z
  .object({
    overview: z.string().min(1, 'overview must not be empty'),
    findings: z.array(FeedbackSignalSummaryFindingSchema).optional(),
    recommendations: z.array(z.string()).optional(),
    keywords: z.array(z.string()).optional(),
    evidence: z.array(FeedbackSignalSummaryEvidenceSchema).optional(),
    confidence: z.number().min(0).max(1).optional(),
    generatedAt: z.string().datetime().optional(),
    clusterTopicTitle: z.string().optional(),
    action: z
      .object({
        suggestion: z.enum(['CREATE', 'UPDATE', 'NONE']),
        reason: z.string(),
        targetTopicId: z.string().optional(),
      })
      .optional(),
  })
  .strict();

export const FeedbackSignalMetadataSchema = z
  .object({
    originalTitle: z.string().optional(),
    summary: FeedbackSignalSummarySchema.optional(),
    keywords: z.array(z.string()).optional(),
    sourceDetails: z.array(z.record(z.string(), z.any())).optional(),
  })
  .catchall(z.unknown());

export type FeedbackSignalSummary = z.infer<typeof FeedbackSignalSummarySchema>;
export type FeedbackSignalMetadata = z.infer<typeof FeedbackSignalMetadataSchema>;

export const ListFeedbackSignalsQuerySchema = z.object({
  status: FeedbackStatusSchema.optional(),
  limit: z.number().min(1).max(100).default(50),
  cursor: z.string().optional(),
  offset: z.number().min(0).optional(),
});

export type ListFeedbackSignalsQueryDTO = z.infer<typeof ListFeedbackSignalsQuerySchema>;

export const GetSignalDailyActivitySchema = z.object({
  days: z.number().min(1).max(90).default(30),
});

export const SignalDailyActivityPointSchema = z.object({
  date: z.string(),
  created: z.number(),
  resolved: z.number(),
});

export const SignalDailyActivitySchema = z.object({
  totals: z.object({
    created: z.number(),
    resolved: z.number(),
  }),
  daily: z.array(SignalDailyActivityPointSchema),
});

export type GetSignalDailyActivityDTO = z.infer<typeof GetSignalDailyActivitySchema>;
export type SignalDailyActivityDTO = z.infer<typeof SignalDailyActivitySchema>;
